<template>
    <div>
        <div class="top">
            <!-- 筛选 -->
            <my-search :order="2" :selectArr="selectArr" :searchParams="searchParams" @searchEvent="searchEvent" />
            <el-button type="primary" icon="el-icon-plus" circle class="addBtn" @click="add"></el-button>
        </div>

        <myTable :loading="loading" :tableData="tableData" :tableHeader="tableHeader" />

        <!-- 分页组件 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />

        <!-- 添加、修改组件 -->
        <my-dialog :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :selectArrAdd="selectArrAdd" :operFormArr="operFormArr" :rules="rules" :loading="loading" @submitForm="submitForm" @closeDialog="closeDialog" @getCurrent="getCurrent">
            <template v-slot:upload>
                <el-upload v-show="uploadShow" class="upload-demo" ref="upload" :auto-upload="true" :multiple="false" action="#" :on-change="fileChange" :http-request="uploadHttpRequest" :file-list="fileList">
                    <el-button type="primary">{{uploadText}}</el-button>
                </el-upload>
                <el-progress :percentage="uploadPercentage" v-show="showPercentage"></el-progress>
            </template>
        </my-dialog>
        <!-- 详情组件 -->
        <my-dialog-detail :isDialogDetailShow.sync="isDialogDetailShow" :operForm="operForm" :operFormArr="operFormArr" :closeDialog="closeDialogDetail" />
    </div>
</template>

<script>
import {
    reqVersionList,
    reqDeleteVer,
    reqUpdateVer,
    reqAddVer,
    uploadApk
} from "@/network/other/version";
import mixins from "@/mixins/common";
import { canSearch } from "../../utils/utils";
export default {
    name: "versionManage",
    mixins: [mixins],
    data() {
        return {
            uploadShow: false,
            uploadText: "上传apk",
            timeinteval: null,
            uploadPercentage: 0,//模拟上传进度条
            showPercentage: false,
            fileList: [],
            tableHeader: Object.freeze([
                {
                    name: "企业名称",
                    prop: "name",
                },
                {
                    name: "类型",
                    prop: "type",
                },
                {
                    name: "版本",
                    prop: "version",
                },
                {
                    name: "是否可用",
                    prop: "deleteStatus",
                },
                {
                    name: "appUrl",
                    prop: "appUrl",
                },
                {
                    prop: "isFirst",
                    name: "是否最新版本",
                },
                {
                    name: "创建时间",
                    prop: "createTime",
                },
                {
                    name: "操作",
                    prop: "operation",
                    width: "300",
                    operation: [
                        {
                            name: "详情",
                            clickFun: this.detail,
                        },
                        {
                            name: "编辑",
                            clickFun: this.edit,
                        },
                        {
                            name: "删除",
                            clickFun: this.delete,
                        },
                    ],
                },
            ]),
            selectArr: [
                {
                    name: "type",
                    defaultText: "请选择任务类型",
                    getData: "label",
                    defaultOptions: [
                        {
                            value: 1,
                            label: "android",
                        },
                        {
                            value: 2,
                            label: "ios",
                        },
                    ],
                },
            ],
            //添加、编辑时文本框所需参数
            operFormArr: [],
            //添加、编辑时下拉框所需参数
            selectArrAdd: [
                {
                    prop: "type",
                    label: "平台",
                    getData: "value",
                    disabled: false,
                    defaultOptions: [
                        { label: "ios", value: "ios" },
                        { label: "android", value: "android" }
                    ],
                },
                {
                    prop: "isFirst",
                    label: "是否最新版本",
                    getData: "value",
                    defaultOptions: [
                        { label: "是", value: "1" },
                        { label: "否", value: "0" }
                    ],
                },
                {
                    prop: "deleteStatus",
                    label: "是否可用",
                    getData: "value",
                    defaultOptions: [
                        { label: "可用", value: "0" },
                        { label: "不可用", value: "1" }
                    ],
                },
            ],
            FormArr: [
                {
                    label: "企业名称",
                    name: "name",
                    defaultText: "请输入企业名称",
                },
                {
                    label: "版本号",
                    name: "version",
                    defaultText: "请输入版本号",
                },
                {
                    label: "更新内容",
                    name: "title",
                    defaultText: "请输入更新内容",
                }
            ],
            editFormArr: [
                {
                    label: "appUrl",
                    name: "appUrl",
                    defaultText: "请输入appUrl",
                    readonly: true
                },
                // {
                // 	label: "apkName",
                // 	name: "apkName",
                // 	defaultText: "",
                // 	readonly:true
                // },
            ],
            //添加、编辑双向绑定值
            operForm: {
                version: "",
                appUrl: "",
                name: "",
                title: "",
                type: "",
                isFirst: "",
                deleteStatus: "",
                apkName: "",
            },
            // 弹出框的表单验证
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入企业简称",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请输入平台",
                        trigger: "blur",
                    },
                ],
                isFirst: [
                    {
                        required: true,
                        message: "请输入版本",
                        trigger: "blur",
                    },
                ],
                deleteStatus: [
                    {
                        required: true,
                        message: "请输入是否可用",
                        trigger: "blur",
                    },
                ],
                version: [
                    {
                        required: true,
                        message: "请输入version",
                        trigger: "blur",
                    },
                ],
                appUrl: [
                    {
                        required: true,
                        message: "请输入appUrl",
                        trigger: "blur",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "请输入title",
                        trigger: "blur",
                    },
                ],
            },
            searchParams: {
                type: "",
            },
        };
    },
    methods: {
        async getInitData(isSearch) {
            let params = {
                data: {
                    // 搜索所有数据的时候为空获取不到
                    type: this.searchParams.type ? this.searchParams.type : undefined,
                },
                current: isSearch ? 1 : this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            let { data } = await reqVersionList(params);
            if (data.code == 200) {
                data.data.records.map((item) => {
                    item.isFirst = item.isFirst == 1 ? "是" : "否";
                    item.deleteStatus = item.deleteStatus == 1 ? "不可用" : "可用";
                });
                this.loading = false;
                this.tableData = data.data.records;
                this.pageParams.total = data.data.total;
                if (isSearch) this.pageParams.currentPage = 1;
            }
        },
        //  搜索事件
        searchEvent() {
            //   if (isUser && canSearch(this, this.searchParams)) return;
            // console.log("搜索了");
            this.getInitData(true);
        },
        detail(row) {
            this.operFormArr = [...this.FormArr, ...this.editFormArr];
            this.isDialogDetailShow = true;
            this.operForm = {
                ...row,
            };
        },
        edit(row) {
            this.operFormArr = [...this.FormArr, ...this.editFormArr];
            this.operTitle = false;
            this.isDialogShow = true;
            if (row.type == 'android') {
                this.uploadShow = true;
            } else {
                this.uploadShow = false;
            }
            this.uploadText = '修改apk'
            let appUrl = row.appUrl;
            if (appUrl.indexOf('apk') != -1) {
                let name = '[^/]+(?!.*/)';
                row.apkName = appUrl.match(name)[0];
            }
            this.selectArrAdd[0].disabled = true;
            this.operForm = {
                ...row,
            };
            this.operForm.isFirst = this.operForm.isFirst == "是" ? "1" : "0";
            this.operForm.deleteStatus = this.operForm.deleteStatus == "不可用" ? "1" : "0";
        },
        delete(row) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let { data } = await reqDeleteVer(row.id);
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getInitData();
                    }
                })
                .catch(() => { });
        },
        add() {
            // 清空
            this.uploadText = '上传apk'
            this.selectArrAdd[0].disabled = false;
            this.operFormArr = this.FormArr;
            this.operForm = this.$options.data().operForm; //初始化状态赋值
            this.operTitle = true;
            this.isDialogShow = true;

        },
        getCurrent(val) {
            if (val == 'android') {
                this.uploadShow = true;
            } else if (val == 'ios') {
                this.uploadShow = false;
            }
        },
        //提交修改
        async submitForm({ valid, operTitle }) {
            // operTitle ture添加  否则是编辑
            if (valid) {
                let api = operTitle ? reqAddVer : reqUpdateVer;
                if (operTitle) {
                    if (!this.operForm.apkName && this.operForm.type == 'android') {
                        this.$message.error("请上传apk");
                        return
                    }
                }
                let { data } = await api(this.operForm);
                if (data.code == 200) {
                    this.isDialogShow = false;
                    this.$message.success("操作成功");
                    this.getInitData();
                }
            }
        },
        //关闭详情
        closeDialogDetail() {
            this.isDialogDetailShow = false;
        },
        //关闭详情
        closeDialog() {
            this.fileList = [];
            this.uploadPercentage = 0;
        },
        // 上传apk
        // 文件发生改变
        fileChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
            }
        },
        async uploadHttpRequest(param) { //上传文件
            await this.submitUpload();
            const formData = new FormData() //FormData对象，添加参数只能通过append('key', value)的形式添加
            formData.append('file', param.file) //添加文件对象
            uploadApk(formData).then(res => {
                if (res.data.code == 200) {
                    this.operForm.apkName = res.data.data;
                    param.onSuccess()  // 上传成功的文件显示绿色的对勾
                    this.$message.success('上传成功');
                    this.uploadPercentage = 100;
                    setTimeout(res => {
                        this.showPercentage = false;
                        this.uploadPercentage = 0;
                    }, 1000)
                }
            }).catch(err => {
                this.uploadPercentage = 0;
                this.showPercentage = false;
                clearInterval(this.timeinteval);
                this.fileList = [];
            })

        },
        submitUpload() {
            //  进度条
            this.uploadPercentage = 0;
            this.showPercentage = true;
            this.timeinteval = setInterval(res => {
                if (this.uploadPercentage >= 99) {  //值是100或99的时候 清空定制器
                    clearInterval(this.timeinteval);
                    return
                }
                this.uploadPercentage++;

            }, 500)
        },
    },
};
</script>

<style scoped lang="scss">
.top {
    height: 100px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
    padding: 0 30px;
}
.addBtn {
    margin: 0 0 10px 20px;
}
.el-progress {
    margin-top: 10px;
}
</style>